import { render, staticRenderFns } from "./CurrentStockTabS0106.vue?vue&type=template&id=6f35508c&"
import script from "./CurrentStockTabS0106.vue?vue&type=script&lang=js&"
export * from "./CurrentStockTabS0106.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports